import $ from 'jquery';

import workNo from '../../fetch/workNo';
import setWorknoSelectBoxOption from '../setWorknoSelectBoxOption';
import wording from '../../wording';

const setupLicsnoInputOnChange = (userInfo) => {
	$('input[name="LICSNO"]').on('change', async (event) => {
		$('.message-box').removeClass('-warning');
		$('.message-box').text('');
		$('#password-login-button').addClass('-disable');
		$('.field[data-rel="apiWORKNO"]').addClass('-hide');
		$('#api-WORKNO').find('option').remove();
		$('input[name="LICSNO"]').val(event.target.value.toUpperCase().replace(/ /g, ''));

		if (event.target.value) {
			const json = await workNo(`JsonStr={
				DLRCD: "${userInfo[0].DLRCD}",
				BRNHCD: "${userInfo[0].BRNHCD}",
				LICSNO: "${encodeURIComponent(event.target.value)}"
			}`);

			/**
			 * failure
			 */
			if (json.rtnCode !== '0') {
				$('.message-box').text(wording.INPUTERROR);
				$('.message-box').addClass('-warning');

				return;
			}

			/**
			 * success
			 */
			setWorknoSelectBoxOption(json.CASWORKNO);
		}
	});
};

export default setupLicsnoInputOnChange;



// WEBPACK FOOTER //
// ./src/js/index/onChange/setupLicsnoInputOnChange.js